module.exports = __webpack_public_path__ + "img/1.01c3f050.svg";